import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faHourglassHalf } from "@fortawesome/free-regular-svg-icons";
import {
  Icon,
  UilChartPie,
  UilShoppingBag,
  UilFileCheckAlt,
  UilMoneyStack,
  UilDashboard,
} from "@iconscout/react-unicons";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import {
  faShieldAlt,
  faPalette,
  faUserShield,
} from "@fortawesome/free-solid-svg-icons";

export interface Route {
  name: string;
  nameEn?: string;
  nameFr?: string;
  icon?: IconProp | string | string[];
  iconSet?: "font-awesome" | "feather" | "unicons";
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  next?: boolean;
}

export interface RouteItems {
  label: string;
  labelEn?: string;
  labelFr?: string;
  horizontalNavLabel?: string;
  horizontalNavLabelEn?: string;
  horizontalNavLabelFr?: string;
  path?: string;
  icon: Icon;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: "dashboard",
    labelEn: "Dashboard",
    labelFr: "Tableau de bord",
    horizontalNavLabel: "home",
    horizontalNavLabelEn: "Home",
    horizontalNavLabelFr: "Accueil",
    active: true,
    path: "/",
    icon: UilChartPie,
    labelDisabled: true,
    pages: [
      {
        name: "dashboard",
        nameEn: "Dashboard",
        nameFr: "Tableau de bord",
        icon: "pie-chart",
        active: true,
        path: "/",
        pathName: "dashboard",
      },
      {
        name: "product-management",
        nameEn: "Product Management",
        nameFr: "Gestion des produits",
        icon: "box",
        active: true,
        pages: [
          {
            name: "add-product",
            nameEn: "Add Product",
            nameFr: "Ajouter un produit",
            path: "/products/add",
            pathName: "e-commerce-add-product",
            active: true,
          },
          {
            name: "products",
            nameEn: "Products",
            nameFr: "Produits",
            path: "/products",
            pathName: "e-commerce-products",
            active: true,
          },
          {
            name: "inventory-requests",
            nameEn: "Inventory Requests",
            nameFr: "Demandes d'inventaire",
            path: "/inventory/requests",
            pathName: "e-commerce-inventory-requests",
            active: true,
          },
          {
            name: "inventory-history",
            nameEn: "Inventory History",
            nameFr: "Historique d'inventaire",
            path: "/inventory/history",
            pathName: "e-commerce-inventory-history",
            active: true,
          },
        ],
      },      
      {
        name: "orders-management",
        nameEn: "Orders Management",
        nameFr: "Gestion des commandes",
        icon: "shopping-bag",
        active: true,
        pages: [
          {
            name: "orders",
            nameEn: "Orders",
            nameFr: "Commandes",
            path: "/orders",
            pathName: "e-commerce-orders",
            active: true,
          },
          // {
          //   name: "returns",
          //   nameEn: "Returns",
          //   nameFr: "Retours",
          //   path: "/orders/refund",
          //   pathName: "e-commerce-refund",
          //   active: true,
          // },

          {
            name: "Refunds",
            nameEn: "RMA",
            nameFr: "RMA",
            path: "/refunds",
            pathName: "e-commerce-refund",
            active: true,
          },
        ],
      },
      {
        name: "billing-management",
        nameEn: "Billing Management",
        nameFr: "Gestion de la facturation",
        active: true,
        icon: "credit-card",
        pages: [
          {
            name: "transaction",
            nameEn: "Transactions",
            nameFr: "Transactions",
            path: "/transactions",
            pathName: "e-commerce-transactions",
            active: true,
          },
          // {
          //   name: "payments",
          //   nameEn: "Payments",
          //   nameFr: "Paiements",
          //   path: "/apps/e-commerce/admin/payments",
          //   pathName: "e-commerce-payments",
          //   active: true,
          // },
          {
            name: "invoices",
            nameEn: "Invoices",
            nameFr: "Factures",
            path: "/invoices",
            pathName: "e-commerce-invoices",
            active: true,
          },
         
        ],
      },
    ],
  },
];
